module.exports = __webpack_public_path__ + "static/media/rufina-rivera.fafd325e.webp";